export default __webpack_public_path__ + "static/media/Calibre-Light.3f254b2d.woff";